import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { debounce } from 'debounce';
import {
    Alert,
    Container, Row, Col, FormGroup,
    InputGroup, InputGroupText,
    Card, CardBody, CardTitle, CardSubtitle,
    Button, Input, Label, UncontrolledTooltip,
    Modal, ModalBody, ModalHeader, ModalFooter,
} from 'reactstrap';

import Slider from '@material-ui/core/Slider';
import AddIcon from '@mui/icons-material/AddOutlined';
import Edit from '@mui/icons-material/Edit';
import Trainings from '@mui/icons-material/LibraryBooks';
import DeleteIcon from '@mui/icons-material/Delete';

import Notes from '@mui/icons-material/Notes';
import ReactCardFlip from 'react-card-flip';
import SearchIcon from '@mui/icons-material/Search';
import DeleteConfirmation from '../components/DeleteConfirmation';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

import * as actions from '../actions/Contacts';
import { getPerson } from '../actions/Person';

import Avatar from '../components/common/FallBackAvatar';
import LookupDropDown from '../components/common/LookupDropDown';
import CheckList from '../components/common/CheckList';
import { Checkbox } from '@material-ui/core';

class Contacts extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            showAdvancedSearchModal: false,
            toDeactivate: '',
            toDelete: '',
            displayDeactivateConfirmation: false,
            displayDeleteConfirmation: false,
            showInactiveContacts: false
        }
    }

    componentDidMount() {
        const { personTypes } = this.props;
        const consultant = personTypes.filter(item => item.name === 'Staff')
        this.props.actions.searchContacts(this.searchTerms, consultant[0].lookupId, this.props.criteria)
        this.props.actions.setSearchCriteriaPersonTypeId(consultant[0].lookupId);
        this.props.actions.getDailyRatesMinMax();
    }

    componentWillUnmount() {
        this.props.actions.clearContacts();
        this.props.actions.clearSearchCriteria();
        this.props.actions.clearAdvancedSearchCriteria();
    }

    handleOnNewContact = () => {
        this.props.actions.newContact(this.personType || this.props.personTypes.find(x => x.name === 'Staff').lookupId);
        this.props.history.push('/persons/new');
    }

    handleCardFlip = (e, isFlipped) => {
        this.props.actions.toggleContactsFlipState(parseInt(e.currentTarget.getAttribute('person-id'), 10), isFlipped);
    }

    handleSearchChange = (e) => {
        this.searchTerms = e.currentTarget.value;
        this.throttledSearch(this.searchTerms, this.props.personTypeId);
    }

    handleTypeChange = (e) => {
        var personTypeId = parseInt(e.currentTarget.value, 10);
        this.props.actions.searchContacts(this.searchTerms, personTypeId, this.props.criteria, this.state.showInactiveContacts)
        this.props.actions.setSearchCriteriaPersonTypeId(personTypeId);
        this.props.actions.setSearchIsActive(true)
    }

    handleEditClick = (id) => {
        this.props.actions.getPerson(id);
        this.props.history.push(`/persons/person/${id}`);
    }

    deleteContact = () => {
        this.props.actions.deleteContact(this.state.toDeleteId, this.searchTerms, this.state.personTypeId, this.props.criteria.toJS(), this.state.showInactiveContacts)
        this.setState({
            displayDeleteConfirmation: false,
            toDelete: '',
            toDeleteId: null
        })
    }

    setContactInactive = () => {
        this.props.actions.setContactInactive(this.state.toDeactivateId, this.searchTerms, this.props.personTypeId, this.props.criteria.toJS(), this.state.showInactiveContacts);
        this.setState({
            displayDeactivateConfirmation: false,
            toDeactivate: '',
            toDeactivateId: null
        })
    }

    notesClicked = (id) => {
        this.props.actions.getPerson(id);
        this.props.history.push({
            pathname: `/persons/person/${id}`,
            personId: { id },
            state: { activeTab: 'Notes' }
        });
    }

    navigateToTrainingTab = (id) => {
        this.props.actions.getPerson(id);
        this.props.history.push({
            pathname: `/programs/`,
            personId: { id },
        });
    }

    throttledSearch = debounce((searchTerm, personTypes) => this.props.actions.searchContacts(searchTerm, personTypes, this.props.criteria, this.state.showInactiveContacts), 500);

    handleToggleAdvancedSearchModal = () => this.setState({ showAdvancedSearchModal: !this.state.showAdvancedSearchModal });

    handleSearch = () => {
        this.handleToggleAdvancedSearchModal();
        this.props.actions.searchContacts(this.searchTerms, this.props.personTypeId, this.props.criteria.toJS(), this.state.showInactiveContacts);
    }

    handleSetActiveConfirmationToggle = (personId) => {
        const person = this.props.Contacts.find(x => x.get('personId') === personId);
        this.setState({
            displayDeactivateConfirmation: !this.state.displayDeactivateConfirmation,
            toDeactivate: person && person.get('displayName'),
            toDeactivateId: personId
        })
    }

    handleDeleteConfirmationToggle = (personId) => {
        const person = this.props.Contacts.find(x => x.get('personId') === personId);
        this.setState({
            displayDeleteConfirmation: !this.state.displayDeleteConfirmation,
            toDelete: person && person.get('displayName'),
            toDeleteId: personId
        })
    }

    handleUserActiveChange = (e) => this.props.actions.setSearchIsActive(e.target.checked);

    setContactActive = (personId, searchTerm, personTypeId, advancedCriteria) => {
        this.props.actions.setContactActive(personId, searchTerm, personTypeId, advancedCriteria, this.state.showInactiveContacts)
    }

    toggleActiveContacts = (e) => {
        this.setState({ showInactiveContacts: !this.state.showInactiveContacts });
        this.props.actions.searchContacts(this.searchTerms, this.props.personTypeId, this.props.criteria, e.target.checked, this.state.showInactiveContacts)
    }

    getEmails = (emails) => {
        if (!emails)
            return [];

        const displayEmailAddress = [];
        emails.forEach((item, index) => {
            const displayPrimary = item.isPrimary === true ? "Primary" : "";
            displayEmailAddress.push(
                <Row key={`email_${index}`} className='pb-1'>
                    <Col>
                        <a href={"mailto:" + item.email}>{item.email}</a>
                    </Col>
                    <Col>
                        <label>{displayPrimary}</label>
                    </Col>
                </Row>
            );
        })

        return displayEmailAddress;
    }

    getAddresses = (addresses) => {
        if (!addresses)
            return;

        return (
            <Row>
                <Col>
                    {addresses.map((x, index) =>
                        <React.Fragment key={`${index}`} >
                            <div><b> {x.addressType} </b></div>
                            <div> {x.address} </div>
                            <br />
                        </React.Fragment>
                    )}
                    < hr />
                </Col>
            </Row >
        );
    }

    getDisciplines = (disciplines) => {
        if (!disciplines)
            return 'NA';

        return disciplines.join(', ');
    }

    getCards = () => {
        const personTypes = this.props.personTypes;
        const cards = [];
        let activateToolTip = [];
        this.props.Contacts.toJS().forEach(x => {
            const { affiliations, dailyRate, imageUrl, isActive, personId, phones, journalEntries, details, isFlipped } = x;
            let affiliationName = [];
            const affiliationMap = affiliations && affiliations.forEach(item => {
                affiliationName.push(' ' + item.program.name);
            })
            let affiliationsString = affiliationName.toString();
            const displayIcon = isActive ?
                <div>
                    <Button className='me-1' id={`deactivateContact_${personId}`} onClick={() => this.handleSetActiveConfirmationToggle(personId)}><DeleteIcon /></Button>
                    <UncontrolledTooltip target={`deactivateContact_${personId}`}>Deactivate Contact</UncontrolledTooltip>
                </div>
                :
                <div>
                    <Button className='me-1' id={`activateContact_${personId}`} onClick={() => this.setContactActive(personId, this.searchTerms, this.props.personTypeId, this.props.criteria.toJS())}><RestoreFromTrashIcon /></Button>
                    <UncontrolledTooltip target={`activateContact_${personId}`} >Activate Contact</UncontrolledTooltip>
                    <Button className='me-1' id={`deleteContact_${personId}`} onClick={() => this.handleDeleteConfirmationToggle(personId, this.searchTerms, this.props.personTypeId, this.props.criteria.toJS())}><DeleteForeverIcon /></Button>
                    <UncontrolledTooltip target={`deleteContact_${personId}`} >Delete Contact</UncontrolledTooltip>
                </div>

            const dailyRateDisplay = dailyRate ? '$' + dailyRate : 'N/A';

            const formatPhone = (phones || []).sort((a, b) => a.isPrimary ? -1 : 1).map((x, index) => {
                const showExtension = x.extension ? `Ext: ${x.extension}` : null;
                const phoneView = <React.Fragment key={`phoneid_${index}`}>
                    <div className='d-flex justify-content-between' style={{ fontWeight: x.isPrimary === true ? 'bold' : 'normal', minWidth: '100%' }}>
                        <span>{`${(x.phoneType && x.phoneType.name) || 'Other'}:`} </span><span>{x.phone.formattedNumber} {showExtension}</span>
                    </div>
                </React.Fragment>
                return phoneView;
            }
            )

            const filterPersonType = personTypes.filter(i => i.lookupId === x.personTypeId)
            console.log('FPT', filterPersonType)
            const newUserObject = {
                ...x,
                personTypeName: filterPersonType[0].name
            }
            cards.push(
                <Col xs='12' lg='6' xl='6' className='p-2 card-col' key={`col_${personId}`}>
                    <div onClick={(e) => this.handleCardFlip(e, isFlipped)} person-id={personId} >
                        <ReactCardFlip isFlipped={isFlipped} flipDirection="horizontal">
                            <Card key={`${personId}-front`} className='contacts-card'>
                                <Row>
                                    <Col xs="3" className="d-flex justify-content-center">
                                        <Avatar alt={x.displayName} imageUrl={imageUrl} />
                                    </Col>
                                    <Col xs="9" className="align-self-center">
                                        <CardTitle>
                                            <span style={{ fontWeight:'bold' }} >{newUserObject.displayName} - {newUserObject.personTypeName}</span>
                                        </CardTitle>
                                    </Col>
                                </Row>
                            </Card>
                            <Card key={`${personId}-back`} className='contacts-card'>
                                {details &&
                                    <CardBody>
                                        <Row className='pb-1'>
                                            <Col className='d-flex justify-content-between'>
                                                <div>
                                                    <Button id={`editContact_${personId}`} className='me-1' onClick={() => this.handleEditClick(personId)}><Edit /></Button>
                                                    <UncontrolledTooltip key={`editContactTooltip_${personId}`} target={`editContact_${personId}`}>Edit Contact</UncontrolledTooltip>
                                                    <Button id={`viewNotes_${personId}`} onClick={() => this.notesClicked(personId)} className='me-1' color={details.numberOfJournalEntries > 0 ? 'info' : 'secondary'}><Notes /></Button>
                                                    <UncontrolledTooltip key={`viewNotesTooltip_{personId}`} target={`viewNotes_${personId}`}>{details.numberOfJournalEntries} Note(s)</UncontrolledTooltip>
                                                    <Button id={`trainings_${personId}`} className='me-1' onClick={() => this.navigateToTrainingTab(personId)}><Trainings /></Button>
                                                    <UncontrolledTooltip key={`viewtrainingsTooltip_${personId}`} target={`trainings_${personId}`}>View Projects</UncontrolledTooltip>
                                                </div>
                                                {displayIcon}
                                            </Col>
                                        </Row>
                                    </CardBody>
                                }
                            </Card>
                        </ReactCardFlip>
                    </div>
                </Col>
            );
        });

        return <React.Fragment>
            {cards}
            {cards.length > 0 &&
                <React.Fragment>
                    {activateToolTip}
                </React.Fragment>}
        </React.Fragment>
    }

    render() {
        const personTypes = this.props.personTypes;
        const dailyRatesMin = this.props.dailyRatesMinMax[0];
        const dailyRatesMax = this.props.dailyRatesMinMax[1];
        const dailyRateRange = this.props.criteria.get('dailyRateRange') || [dailyRatesMin, dailyRatesMax];
        const containsAll = personTypes.some(u => u.name === 'All')
        if (containsAll !== true)
            personTypes.unshift({ lookupId: null, name: 'All' })

        //This was done to preselect the contact user type of Consultant based on a user request
        //2/3 preselect staff
        const staffType = personTypes.filter(item => item.name === 'Staff')
        const staffTypeId = staffType[0].lookupId;
        const preselectConsultant = this.props.personTypeId === undefined ? staffTypeId : this.props.personTypeId;

        return (
            <Container className='container-wide'>
                <Modal isOpen={this.state.showAdvancedSearchModal} toggle={this.handleToggleAdvancedSearchModal} size='lg' >
                    <ModalHeader toggle={this.handleToggleAdvancedSearch}>Advanced Search Options</ModalHeader>
                    <ModalBody>
                        <Row className='mb-5'>
                            <Col>
                                <InputGroup>
                                    <InputGroupText>City:</InputGroupText>
                                    <Input
                                        name='city'
                                        onChange={this.props.actions.setSearchCriteria}
                                        value={this.props.criteria.get('city') || ''}
                                    >
                                    </Input>
                                </InputGroup>
                            </Col>
                            <Col>
                                <LookupDropDown
                                    label='State'
                                    idSelector='stateId'
                                    nameSelector='name'
                                    name='state'
                                    onChange={this.props.actions.setSearchCriteriaState}
                                    dropdownPlaceholder='Select'
                                    lookups={this.props.states}
                                    value={this.props.criteria.get('state') || null}
                                    inline={true}
                                />
                            </Col>
                        </Row>
                        <FormGroup>
                            <Label className='font-weight-bold'>Daily Rate Range:</Label>
                            <Slider
                                value={dailyRateRange}
                                onChange={this.props.actions.setSearchCriteriaDailyRateRange}
                                valueLabelDisplay="auto"
                                aria-labelledby="range-slider"
                                step={1}
                                min={dailyRatesMin}
                                max={dailyRatesMax}
                                getAriaValueText={(value, index) => `$${value}`}
                                valueLabelFormat={(x) => `$${x}`}
                            />
                            <Label>{`$${dailyRateRange[0]} to $${dailyRateRange[1]}`}</Label>
                        </FormGroup>
                        <FormGroup>
                            <Label className='font-weight-bold'>Court Type(s):</Label>
                            <CheckList
                                id='courtTypeCheckList'
                                selected={this.props.criteria.get('courtTypes')}
                                items={this.props.courtTypes.map(x => ({ id: x.lookupId, name: x.name }))}
                                onChange={this.props.actions.setSearchCriteriaCourtTypes}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label className='font-weight-bold'>Discipline(s):</Label>
                            <CheckList
                                id='disciplineCheckList'
                                selected={this.props.criteria.get('disciplines')}
                                items={this.props.disciplines.map(x => ({ id: x.lookupId, name: x.name }))}
                                onChange={this.props.actions.setSearchCriteriaDisciplines}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label className='font-weight-bold'>Is Active:</Label>
                            <Checkbox
                                onChange={this.handleUserActiveChange} checked={this.props.criteria.get('isActive')}
                            />
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.handleSearch}>Search</Button>{' '}
                        <Button color="secondary" onClick={this.props.actions.clearAdvancedSearchCriteria}>Clear</Button>
                        <Button color="secondary" onClick={this.handleToggleAdvancedSearchModal}>Cancel</Button>
                    </ModalFooter>
                </Modal>
                <Row className='justify-content-center m-0'>
                    {/*<Col className='col-4 align-self-center p-2'>*/}
                    {/*    <LookupDropDown*/}
                    {/*        label='Type'*/}
                    {/*        name='personTypeId'*/}
                    {/*        onChange={this.handleTypeChange}*/}
                    {/*        lookups={personTypes}*/}
                    {/*        value={preselectConsultant}*/}
                    {/*        inline={true}*/}
                    {/*    />*/}
                    {/*</Col>*/}
                    <Row className='justify-content-start m-0'>
                        <Col className='col-4 align-self-center p-2'>
                            <Input onChange={this.handleSearchChange} />
                        </Col>
                        <Col className='col-3 align-self-center p-2'>
                            <Checkbox id='showInactive' onChange={this.toggleActiveContacts} checked={this.state.showInactiveContacts} />
                            <Label style={{ paddingTop: '10px' }}>Inactive Contacts</Label>
                        </Col>
                    </Row>

                    {/*<Col className='p-2 text-end'>*/}
                    {/*    <Button id='btnSearchModal' className='me-1' onClick={this.handleToggleAdvancedSearchModal} color={this.props.hasAdvancedSearchCriteria ? 'info' : 'secondary'}><SearchIcon /></Button>*/}
                    {/*    <UncontrolledTooltip target='btnSearchModal'>Advanced Search.</UncontrolledTooltip>*/}
                    {/*    <Button id="btnNewContact" onClick={this.handleOnNewContact}><AddIcon /></Button>*/}
                    {/*    <UncontrolledTooltip target='btnNewContact'>Add a New Contact.</UncontrolledTooltip>*/}
                    {/*</Col>*/}
                </Row>
                <Row className='mr-0 ml-0'>
                    {this.props.Contacts.size > 0 ? this.getCards() : <Col><Alert color='warning'>No Contacts Found.</Alert></Col>}
                </Row>
                <DeleteConfirmation
                    deactivateContcact={true}
                    title={`Deactivate Contact`}
                    onDelete={this.setContactInactive}
                    onToggle={this.handleSetActiveConfirmationToggle}
                    contactName={this.state.toDeactivate}
                    isOpen={this.state.displayDeactivateConfirmation}
                />
                <DeleteConfirmation
                    deleteContact={true}
                    title={`Delete Contact`}
                    onDelete={this.deleteContact}
                    onToggle={this.handleDeleteConfirmationToggle}
                    contactName={this.state.toDelete}
                    isOpen={this.state.displayDeleteConfirmation}
                />
            </Container>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        Contacts: state.SearchResults.get('contacts'),
        criteria: state.SearchResults.get('criteria'),
        personTypeId: state.SearchResults.get('personTypeId'),
        hasAdvancedSearchCriteria: state.SearchResults.get('hasAdvancedSearchCriteria'),
        dailyRatesMinMax: state.SearchResults.get('dailyRatesMinMax')
    };
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators({ ...actions, getPerson }, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(Contacts);